import React from "react";
import RevealAnimation from "../RevealAnimation";

function NewCtaSection({ title, buttonLabel, pagePath }) {
  return (
    <div className="CtaCardBoxSection">
      <div className="body-container">
        <div className="boxSection-body">
          <RevealAnimation animation="slide-left">
            <h3 className="boxSection-title">{title}</h3>
          </RevealAnimation>
          <a
            href={pagePath}
            style={{ textDecoration: "none" }}
            className="digiryte-submit"
          >
            {buttonLabel} <span className="arrow">&rarr;</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default NewCtaSection;
